import type { ReactNode } from 'react';
import { ComboboxItem } from './Combobox';

export type ComboboxOptionProps = {
  value: string;
  children: ReactNode;
};

export const ComboboxOption = ({ value, children }: ComboboxOptionProps) => {
  return (
    <ComboboxItem
      className="combobox-item"
      focusOnHover={true}
      value={value}
    >
      {children}
    </ComboboxItem>
  );
};
